{
    "Profile_Residents.residents": "FR: Residents",
    "Profile_Residents.resident": "FR: Resident {number}"
}
